import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Profile from '@/router/profile'
import Areas from '@/router/areas'
import Courses from '@/router/courses'
import Partners from '@/router/partners'
import Authentication from '@/router/authentication'
import Certificates from '@/router/certificates'
import Errors from '@/router/errors'
import News from '@/router/news'
import store from '@/store'

Vue.use(VueRouter)

const Core = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('@/views/about'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/about/history',
        name: 'AboutHistory',
        component: () => import('@/views/about/History'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/about/team',
        name: 'AboutTeam',
        component: () => import('@/views/about/Team'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/about/certificates-awards',
        name: 'AboutCertificates',
        component: () => import('@/views/about/Certificates'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/about/mission',
        name: 'AboutMission',
        component: () => import('@/views/about/Mission'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/terms-and-services',
        name: 'TermsServices',
        component: () => import('@/views/misc/TermsServices'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/privacy-policy',
        name: 'PrivacyPolicy',
        component: () => import('@/views/misc/PrivacyPolicy'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/sitemap',
        name: 'Sitemap',
        component: () => import('@/views/misc/Sitemap'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/contact',
        name: 'Contact',
        component: () => import('@/views/contact'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/cart',
        name: 'Cart',
        component: () => import('@/views/Cart'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/checkout',
        name: 'Checkout',
        component: () => import('@/views/checkout'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/wishlist',
        name: 'Wishlist',
        component: () => import('@/views/Wishlist'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/classes',
        name: 'Classes',
        component: () => import('@/views/Classes'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/payment/:orderId/:invoiceId',
        name: 'Payment',
        component: () => import('@/views/payment'),
        meta: {
            requiresAuth: true,
        },
    },
    Profile,
]

var allRoutes = []
allRoutes = allRoutes.concat(
    Core,
    Areas,
    Courses,
    Partners,
    Authentication,
    Certificates,
    News,
    Errors
) // Errors always at last because route for 404

const routes = allRoutes

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((route) => route.meta.requiresAuth)) {
        if (!store.getters['session/isAuthenticated']) {
            //this route requires auth, check if logged in; if not, redirect to login page.
            next({
                path: '/login', // redirect to login page
                query: { redirect: to.fullPath }, // save the location we were at to come back later
            })
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router
